import { render, staticRenderFns } from "./tour_price_details.vue?vue&type=template&id=c88550ca&"
import script from "./tour_price_details.vue?vue&type=script&lang=js&"
export * from "./tour_price_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports